import React from "react";

function RemoveIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 20.269 20.269">
      <path
        d="M13.51,3.375A10.135,10.135,0,1,0,23.644,13.51,10.133,10.133,0,0,0,13.51,3.375Zm2.568,13.8L13.51,14.611l-2.568,2.568a.779.779,0,1,1-1.1-1.1l2.568-2.568L9.841,10.942a.779.779,0,0,1,1.1-1.1l2.568,2.568,2.568-2.568a.779.779,0,0,1,1.1,1.1L14.611,13.51l2.568,2.568a.782.782,0,0,1,0,1.1A.773.773,0,0,1,16.077,17.178Z"
        transform="translate(-3.375 -3.375)"
      />
    </svg>
  );
}

export { RemoveIcon };
